import { API } from '../../api';
import { Button, Input } from 'antd';
import React, { useState } from 'react';

const AddMappingFlag = props => {
  const [flagContent, setFlagContent] = useState('');

  const saveFlag = async () => {
    await API.put(`/mapping/${props.mapping.id}`, { flag_content: flagContent });
    await props.getMapData();
  };

  const cancelAdd = () => {
    setFlagContent('');
    props.handlePopoverOpenChange(false);
  };

  const clearFlagContent = () => {
    setFlagContent('');
  };

  return (
    <div id={`add_flag_mapping_${props.mapping.id}`}>
      <Input.TextArea
        value={flagContent}
        onChange={e => setFlagContent(e.target.value)}
        autoSize={{ minRows: 2 }}
        style={{ marginBottom: '20px', marginTop: '10px' }}
        autoFocus
      />
      <div style={{ width: '400px', display: 'flex', justifyContent: 'end' }}>
        <Button onClick={saveFlag} type="primary">
          Save
        </Button>
        <Button onClick={clearFlagContent} style={{ marginLeft: '10px' }}>
          Clear
        </Button>
        <Button onClick={cancelAdd} style={{ marginLeft: '10px' }}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

AddMappingFlag.propTypes = {};

export default AddMappingFlag;
